import { FACET_STATE } from 'hooks/useFacetsState';
import { isEmpty } from 'lodash';
import { FilterComparatorType, OperatorType } from 'types';

export const mergeQueryStrings = (queryStrings) => {

	const orValues = [].concat.apply([], queryStrings.map(queryString => queryString[OperatorType.Or] || []));
	const andValues = [].concat.apply([], queryStrings.map(queryString => queryString[OperatorType.And] || []));

	const returnValue = {};
	if (orValues.length) returnValue[OperatorType.Or] = orValues;
	if (andValues.length) returnValue[OperatorType.And] = andValues;

	return returnValue;
}

// converts items in the filters into the query syntax that gets passed back to the SRS filter api.
export const getQueryString = (key, filter) => {
	if (key === null || isEmpty(filter)) return {};
	// generate query string for facets
	else if (key === 'activeFacets') {
		let queryString = Object.entries(filter || {}).map(([key, values]) => {
			const onValues = Object.entries(values)
				.filter(([, state]) => {
					return state === FACET_STATE.ON;
				})
				.map(([value]) => {
					return { [key]: value };
				});

			const offValues = Object.entries(values)
				.filter(([, state]) => {
					return state === FACET_STATE.OFF;
				})
				.map(([value]) => {
					return { [key]: { [FilterComparatorType.NotEquals]: value } };
				});

			const returnValue = {};
			if (onValues.length) returnValue[OperatorType.Or] = onValues;
			if (offValues.length) returnValue[OperatorType.And] = offValues;

			return returnValue;
		});
		return { $and: queryString };
	}
	// generate query string for hierarchical facets
	else if (key === 'activeHierarchicalFacets') {
		let queryString = Object.entries(filter || {}).map(([key, values]) => {
			const onValues = Object.entries(values)
				.filter(([, state]) => {
					return state === FACET_STATE.ON;
				})
				.map(([value]) => {
					return { [key]: { [FilterComparatorType.StartsWith]: value } };
				});

			const offValues = Object.entries(values)
				.filter(([, state]) => {
					return state === FACET_STATE.OFF;
				})
				.map(([value]) => {
					return { [key]: { [FilterComparatorType.NotStartsWith]: value } };
				});

			const returnValue = {};
			if (onValues.length) returnValue[OperatorType.Or] = onValues;
			if (offValues.length) returnValue[OperatorType.And] = offValues;

			return returnValue;
		});
		return { $and: queryString }
	}
	// generate query string for timeline
	else if (key === 'timeline') {
		const { timeProperty, timeExtents } = filter;
		if (!timeProperty || !timeExtents)
			return;

		const queryString = {
			$and: [
				{ [timeProperty.name]: { [FilterComparatorType.GreaterThanEquals]: timeExtents[0] } },
				{ [timeProperty.name]: { [FilterComparatorType.LessThan]: timeExtents[1] } }
			]
		}
		return queryString;
	}
	else {
		return {};
	}
}
